import { useEffect, useState } from "react";

const readLayout = () => ({
  isMobile: window.innerWidth <= 1023,
  isMobileDevice:
    /Android|iPhone|iPad|iPod|Mobile/i.test(window.navigator.userAgent || "") ||
    (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1),
  isStandalone:
    window.matchMedia?.("(display-mode: standalone)").matches === true ||
    window.navigator.standalone === true,
});

export default function useMobileLayout() {
  const [layout, setLayout] = useState(readLayout);

  useEffect(() => {
    const standalone = window.matchMedia?.("(display-mode: standalone)");
    const update = () => setLayout(previous => {
      const next = readLayout();
      return previous.isMobile === next.isMobile && previous.isStandalone === next.isStandalone
        ? previous
        : next;
    });
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    window.addEventListener("appinstalled", update);
    standalone?.addEventListener?.("change", update);

    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
      window.removeEventListener("appinstalled", update);
      standalone?.removeEventListener?.("change", update);
    };
  }, []);

  return {
    ...layout,
    isMobile:
      new URLSearchParams(window.location.search).get("mobile") === "1" ||
      layout.isMobile,
  };
}
